//deps
import React, { memo } from "react";

//internal-deps
import { TURBO_PAYMENT_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";

//styles
import {
    PaymentMethodIcon,
    PrimaryCta,
    ShimmerContainer,
    ShimmerContent,
    ShimmerTextContainer,
    TextPlaceholder,
} from "./styles/TurboPaymentWidgetShimmer.style";

const TurboPaymentWidgetShimmer = () => {
    return (
        <ShimmerContainer data-testid={TURBO_PAYMENT_WIDGET_DATA_TEST_IDS.SHIMMER}>
            <ShimmerContent>
                <PaymentMethodIcon />
                <ShimmerTextContainer>
                    <TextPlaceholder />
                    <TextPlaceholder height={11} width={64} />
                </ShimmerTextContainer>
            </ShimmerContent>
            <PrimaryCta />
        </ShimmerContainer>
    );
};

export default memo(TurboPaymentWidgetShimmer);
